import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash';
import { Form } from 'react-bootstrap';

import {
  getMapServerUrl,
  getName
} from '../../../api/MapServerElements/map-server-element-operations';

const LayerDefaultURLField = ({
  mapServerElementUrlList,
  mapServerElementUrl,
  handleUrlChange
}) => {
  if (!isEmpty(mapServerElementUrlList)) {
    return (
      <Form.Control
        as="select"
        name="default-url-layer"
        defaultValue={mapServerElementUrl}
        onChange={handleUrlChange}
      >
        <option value="">Other...</option>
        {map(mapServerElementUrlList, mapServerElement => {
          return (
            <option value={getMapServerUrl(mapServerElement)} key={getName(mapServerElement)}>
              {getName(mapServerElement)}
            </option>
          );
        })}
      </Form.Control>
    );
  }
  return '';
};
LayerDefaultURLField.propTypes = {
  mapServerElementUrlList: PropTypes.array.isRequired,
  mapServerElementUrl: PropTypes.string.isRequired,
  handleUrlChange: PropTypes.func.isRequired
};

export default LayerDefaultURLField;
